import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AnswerModuleResponse } from '@shared/models/answer-module-response';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationStateService {
  private _hideBackButton = new BehaviorSubject<boolean>(
    this.getSavedHideBackButton(),
  );
  hideBackButton$: Observable<boolean> = this._hideBackButton.asObservable();

  setHideBackButton(value: boolean): void {
    this._hideBackButton.next(value);
    sessionStorage.setItem('hideBackButton', JSON.stringify(value));
  }

  private getSavedHideBackButton(): boolean {
    const saved = sessionStorage.getItem('hideBackButton');
    return saved !== null ? JSON.parse(saved) : true;
  }

  get currentHideBackButtonValue(): boolean {
    return this._hideBackButton.getValue();
  }

  updateFromResponse(response: HttpResponse<AnswerModuleResponse>): void {
    const shouldHide = this.shouldHideBackButton(response);
    this.setHideBackButton(shouldHide);
  }

  private shouldHideBackButton(
    response: HttpResponse<AnswerModuleResponse>,
  ): boolean {
    return !response?.body?.enableBackNavigation;
  }
}
